import { NgModule} from '@angular/core';
import {LoginComponent } from './login/login.component';
import {SignupComponent } from './signup/signup.component';

import {ReactiveFormsModule } from '@angular/forms';
import { AngularFireAuthModule} from 'angularfire2/auth';
import { SharedModule} from '../shared/shared.imports';
import {AuthRouterModule } from './auth-router';
@NgModule({
declarations:[SignupComponent,LoginComponent],
imports:[AngularFireAuthModule,ReactiveFormsModule,SharedModule,AuthRouterModule],
exports:[]
})
export class AuthImports{

}